var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 0q2.07 0 3.883.784a10 10 0 0 1 3.185 2.148 10 10 0 0 1 2.148 3.185A9.7 9.7 0 0 1 20 10q0 2.07-.784 3.883a10.2 10.2 0 0 1-2.148 3.185 10 10 0 0 1-3.185 2.148A9.7 9.7 0 0 1 10 20a9.7 9.7 0 0 1-3.883-.784 10 10 0 0 1-3.185-2.148 10.3 10.3 0 0 1-2.158-3.185A9.8 9.8 0 0 1 0 10q0-2.07.774-3.883a10.2 10.2 0 0 1 2.158-3.185A10 10 0 0 1 6.117.784 9.7 9.7 0 0 1 10 0m0 13a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m0-8.84a.875.875 0 0 0-.875.874v5.734a.875.875 0 0 0 1.75 0V5.034A.875.875 0 0 0 10 4.16",
    clipRule: "evenodd"
  })));
};
export default SvgWarning;